// @flow
import {Children, PureComponent} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

/* global google */

export default class Overlay extends PureComponent {
    static propTypes = {
        /** Single child to be rendered under overlay */
        children: PropTypes.node.isRequired,
        /** URL to an image for the close button of the overlay */
        closeBoxURL: PropTypes.string,
        /** google.maps.Size() */
        pixelOffset: PropTypes.shape({
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
        }),
        /** google.maps.Size() */
        infoBoxClearance: PropTypes.shape({
            width: PropTypes.number.isRequired,
            height: PropTypes.number.isRequired,
        }),
        /** marker reference (automatically passed down if wrapped by Marker) */
        marker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        /** map reference (automatically passed down if wrapped by GoogleMap) */
        map: PropTypes.object, // eslint-disable-line react/forbid-prop-types
        alignBottom: PropTypes.bool,
        boxStyle: PropTypes.object,
    };

    static defaultProps = {
        closeBoxURL: '',
        pixelOffset: {
            height: 0,
            width: 0,
        },
        infoBoxClearance: {
            height: 0,
            width: 0,
        },
        alignBottom: false,
        boxStyle: {},
    };

    constructor(props) {
        super(props);

        const {
            closeBoxURL,
            pixelOffset,
            infoBoxClearance,
            map,
            alignBottom,
            boxStyle,
        } = props;
        const {InfoBox} = require('google-maps-infobox');
        const infobox = new InfoBox({
            closeBoxURL,
            pixelOffset: new google.maps.Size(
                pixelOffset.width,
                pixelOffset.height
            ),
            infoBoxClearance: new google.maps.Size(
                infoBoxClearance.width,
                infoBoxClearance.height
            ),
            alignBottom,
            boxStyle,
        });
        infobox.setMap(map);
        this.infobox = infobox;
        this.markerContent = document.createElement('div');
        this.infobox.setContent(this.markerContent);
    }

    componentDidMount() {
        const {map, marker} = this.props;
        this.infobox.setContent(this.markerContent);
        this.infobox.open(map, marker);
    }
    componentWillUnmount() {
        if (this.infobox && this.infobox.getContent()) {
            this.infobox.setMap(null);
        }
    }

    render() {
        return ReactDOM.createPortal(
            Children.only(this.props.children),
            this.markerContent
        );
    }
}
